// preLoader
// @import "base/modules/loader";
let loader = document.querySelector('.preloader');
const loaderFunc = () => {
    document.querySelector('body').classList.add('lock');
    setTimeout(() => {
        document.querySelector('body').classList.remove('lock');
        loader.remove();
    }, 5)
}
if (document.readyState === 'complete' || document.readyState !== 'loading') {
    loaderFunc();
} else {
    window.addEventListener('load', loaderFunc);
}

import './modules/mika-moving-element.js';
import './modules/pwm-form-select.js';
//import "./modules/another_author/dynamic_adapt.js";

// Slider
import Slider from "./modules/slider.js";
import Gallery from "./modules/gallery.js";
//import Gallery from "./modules/test.js";
//import lazyLoadImg from "./modules/lazyloadimg.js";

import * as tech from './modules/tech/tech.js';
import Menu from './modules/menu.js';
//import Modal from './modules/modal.js';
import Modal from './modules/modal.js';
import * as  formsOld from './modules/forms.js';
//import * as forms from './modules/forms.js';
//import { enableScroll, disableScroll } from './modules/tech/toggle-scroll.js';
import * as video from './modules/video.js';
import * as die from './modules/mod/die.js';
import * as flsFunctions from "./files/functions.js";
//import initGallery from "./modules/galleryApp.js";
import animation from './modules/pwm-animate.js';

tech.isDevice();
tech.webP();

document.addEventListener('DOMContentLoaded', () => {
    "use strict"

    //movingElement();

    /********************* Lang Toggle *********************/
    const lang = document.querySelector('.lang__title');
    if (lang) {
        lang.addEventListener('click', (e) => {
            e.preventDefault;
            let cont = e.target.closest('.lang');
            if (cont) {
                cont.classList.toggle('open');
            }
        });
    }

    // go back
    const goBack = () => {
        const btn = document.querySelector('[data-goback]');
        if (btn) {
            btn.addEventListener('click', () => {
                history.back();
            });
        }
    }
    goBack();

    /*if (!tech.getCookies('checkModal')) {
        const checkModal = localStorage.getItem('checkModal');
        if (!checkModal) {
            document.body.addEventListener('mouseout', function (e) {
                if (!e.relatedTarget && !e.toElement) {
                    const modal = new Modal('application', 'checkModal');
                    tech.setCookies('checkModal', 'true', 0, 3);

                }
            });
        }
    }*/

    /********************* Animation *********************/
    //animation();

    /********************* Scroll To Hash *********************/
    const scrollToHash = (type) => {
        const linkHash = document.querySelectorAll('[href^="#"]');
        let cymbol;
        if (type === '#') {
            cymbol = '#';
        } else if (type === '.') {
            cymbol = '.';
        } else {
            cymbol = '';
        }
        const stepHash = (el) => {
            let w = window.pageYOffset,  // производим прокрутка прокрутка
                V = 0.3,
                start = null;
            //console.log(w)
            const scrollTo = (t, hash) => {
                const step = (time) => {
                    if (start === null) start = time;
                    var progress = time - start,
                        r = (t < 0 ? Math.max(w - progress / V, w + t) : Math.min(w + progress / V, w + t));
                    window.scrollTo(0, r);
                    if (r != w + t) {
                        requestAnimationFrame(step)
                    } else {
                        location.hash = hash  // URL с хэшем
                    }
                }
                requestAnimationFrame(step);  // подробнее про функцию анимации [developer.mozilla.org]
            }

            const scrollTo2 = (hash) => {
                const offsetPosition = document.querySelector(cymbol + hash).getBoundingClientRect().top;
                //setTimeout(() => {
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
                // }, 1);
            }
            if (el) {
                const hash = el.replace(/#/g, '');  // к id элемента, к которому нужно перейти

                //setTimeout(() => {
                let t = document.querySelector(cymbol + hash).getBoundingClientRect().top - 70; // отступ от окна браузера до id
                scrollTo(t, hash);
                //}, 5000);
                //scrollTo2(hash);
                //console.log(hash)

            } else { // has url scroll
                const hash = new URL(document.URL).hash.replace(/#/g, '');
                if (hash) {
                    let t = document.querySelector(cymbol + hash).getBoundingClientRect().top - 70;  // отступ от окна браузера до id
                    scrollTo(t, hash);
                    //scrollTo2(hash);
                    //console.log(hash)

                }
            }
        }
        if (linkHash.length > 0) {
            for (var i = 0; i < linkHash.length; i++) {
                linkHash[i].addEventListener('click', (e) => {
                    e.preventDefault();
                    const hash = e.target.attributes.href.nodeValue.replace(/#/g, '');
                    location.hash = hash;
                    stepHash(e.target.attributes.href.nodeValue)
                })
            }
        }
        stepHash();
    }
    scrollToHash('#'); // #id, .class

    // Aside 
    /*const observer = new IntersectionObserver((entries) => {
        const nav = document.querySelectorAll('.aside-content-list__link');
        //console.log(entries);
        if (nav.length > 0) {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    document.querySelectorAll('.aside-content-list__link').forEach((link) => {
                        let id = link.getAttribute('href').replace('#', '');
                        if (id === entry.target.id) {
                            link.parentElement.classList.add('aside-content-list__item--active');
                        } else {
                            link.parentElement.classList.remove('aside-content-list__item--active');
                        }
                    });
                }
            });
        }
    }, {
        threshold: 0.5
    });
    document.querySelectorAll('[id]').forEach(section => { observer.observe(section) });
    */

    /********************* Burger *********************/
    /* Burger ****
    * element burger, element menu, if (element arrow submenu)
    * die.burgerMenu('.burger', '.header__menu');
    * die.burgerMenu('.burger', '.header__menu', '.menu__item--arrow');
    * die.burgerMenu('.burger', '.header__nav', '.menu__item--arrow', 'overlay');
    */
    // !!!
    die.burgerMenu('.burger', '.header__nav');
    /*const menu = new Menu('.menu', {
        isMore: true,
        isMobile: false,
        breakpointMore: 768,
        widthObjects: ['.header__branding'],
    });*/

    window.onscroll = function () {
        /********************* Fixed Header *********************/
        // add main padding top - true, false
        //die.fixed('.header', true);


        /********************* To Top *********************/
        /*
        * style scss @import "base/modules/to-top";
        * <div class="_to-top"></div>
        */
        die.toTop();
        /**
         * <div class="_to-top">
             <svg class="_to-top__circle" viewBox="-10 -10 300 300">
               <circle class="_to-top__circle--progress" r="140" cx="140" cy="140" fill="none" stroke="crimson" stroke-width="20"></circle>
             </svg>
           </div>
         */
        //die.toTop('animation');

        /********************* Progress Line *********************/
        /*
         * style scss @import "base/modules/progressline";
         * <div class="progressline">
             <div class="progressline__line"></div>
           </div>
         */
        //die.progressLine();
    }

    /********************* Fixed Menu Logic *********************/
    //die.fixedLogic(".header__nav", ".header");

    /********************* LazyLoad IMG *********************/
    //lazyLoadImg();



    /********************* Fullscreen *********************/
    // style scss @import "base/modules/fullscreen";
    // data-fullscreen or data-fullscreen=".header"
    //die.fullscreen();

    /********************* Spoilers *********************/
    /* Спойлери
    * data-spoiler="767,max"
    * data-spoiler="767,min"
    */
    die.spoilers();


    /********************* IMG to Background *********************/
    // Img to background-mage
    // style scss @import "base/modules/img-to-bg";
    //die.imgToBackground();

    /********************* Counter Animation *********************/
    // Counter
    // data-count="0,300,5000,+"
    // style scss @import "base/modules/progressbar";
    //die.countAnimation();

    /********************* Video Thumbnail *********************/
    //video.getVideosThumbnail();

    /********************* Video PopUp *********************/
    //video.videoPopup();

    /********************* ElemScrollTo *********************/
    /**
     * <li class="scroll-to"><a href="#to-block">item</a></li>
     * <button data-to="#to-block">Text</button>
     * <div class="to-block">content</div>
     */
    //die.elementsScrollTo('class'); // 'class', 'id'

    /********************* Current Year *********************/
    // Example <span class="current-year"></span>
    //die.currentYear('.current-year');

    formsOld.form();

    // style scss @import "base/modules/modal";
    /**
     * <a href="#" data-modal="orderAdvertising" aria-label="Open modal" class="btn _modal-btn">Open modal</a>
     *<div class="_modal">
        <div class="_modal__block orderAdvertising" data-target="first">
            Modal content
        </div>
    </div>
     */

    //forms.sendForm('contact2, contact3');

    /*
    setTimeout(() => {
        die.showhide('.showhide');
    }, 800);
    */



    /********************* FAQ *********************/
    //die.faq('.pwmfag__question', '.pwmfag__icon');

    /********************* Dynamic height header *********************/
    const header = document.querySelectorAll('.header');
    if (header) {
        let height = header[0].offsetHeight;
        document.body.style = `--header-height: ${height}px`;

        let mdQueriesArray = tech.dataMediaQueries(header, "height");

        if (mdQueriesArray && mdQueriesArray.length) {
            mdQueriesArray.forEach(mdQueriesItem => {
                // EEvents
                mdQueriesItem.matchMedia.addEventListener("change", function () {
                    height = document.querySelector('.header').offsetHeight;
                    document.body.style = `--header-height: ${height}px`;
                });
            });
        }
    }





    /********************* Cookie Modals *********************/
    // Cookie Modals
    // die.cookieModal('.cookie_accept');

    const modal = new Modal();


});

//console.log(window.navigator.userAgent.toLowerCase('/chrome/'))



/********************* Swiper Slider *********************/
/*
Основниые модули слайдера:
Navigation, Pagination, Autoplay,
EffectFade, Lazy, Manipulation
Подробнее смотри https://swiperjs.com/
*/

/*
Основниые модули слайдера:
Navigation, Pagination, Autoplay,
EffectFade, Lazy, Manipulation
Подробнее смотри https://swiperjs.com/
*/


import Swiper, { Autoplay, Navigation, Pagination, Thumbs, Controller, EffectFade } from 'swiper';
//import { exit } from 'browser-sync';
Swiper.use([Navigation, Controller]);
//Swiper.use([Autoplay, Navigation, Pagination, Controller, EffectFade]);

if (document.querySelector('.pwmreview__slider')) {
    new Swiper('.pwmreview__slider', {
        modules: [Navigation],
        slidesPerView: 2,
        spaceBetween: 20,
        noSwiping: true,
        //autoHeight: false,
        loop: true,
        //centeredSlides: true,
        //mousewheel: true,
        //allowTouchMove: true,
        //slideToClickedSlide: true,
        //freeMode: true,
        lazy: {
            loadPrevNext: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            320: {
                slidesPerView: "auto",
                spaceBetween: 16,
                //centeredSlides: true,
            },
            720: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
        }
    });

    let th = new Swiper('.pwmreview__imgthumb', {
        slidesPerView: 4,
        spaceBetween: 0,
        noSwiping: false,
        clickable: true,
        slideToClickedSlide: true,
        navigation: {
            nextEl: '.btn-next',
            prevEl: '.btn-prev',
        },
        breakpoints: {
            320: {
                direction: 'vertical',
            },
            990: {
                direction: 'horizontal',
            },
        }
    });

    let activesl = new Swiper('.pwmreview__active', {
        slidesPerView: 1,
        spaceBetween: 0,
        noSwiping: false,
        navigation: {
            nextEl: '.btn-next',
            prevEl: '.btn-prev',
        }
    });

    //th.controller.control = activesl;
}

if (document.querySelector('.listcat__slider')) {
    const listcat = new Swiper('.listcat__slider', {
        modules: [Navigation],
        slidesPerView: 2,
        spaceBetween: 20,
        //autoHeight: false,
        loop: true,
        //centeredSlides: true,
        //mousewheel: true,
        //allowTouchMove: true,
        //slideToClickedSlide: true,
        //freeMode: true,
        lazy: {
            loadPrevNext: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            320: {
                slidesPerView: "auto",
                spaceBetween: 16,
                //centeredSlides: true,
            },
            540: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            1000: {
                slidesPerView: 4,
                spaceBetween: 20,
            },
        }
    });
}




/********************* Mask Phone *********************/
/********************* Flags Phone *********************/
// input tel mask and flags
/*import "./modules/another_author/intlTelInput.js";
if (document.querySelector("#cfphone")) {
    let input = document.querySelector("#cfphone");
    window.intlTelInput(input, {
        initialCountry: "us",
        preferredCountries: ['es'],
        allowDropdown: false,
        showFlags: false
        //formatOnDisplay: true,
    });
}
import "./modules/another_author/utils.js";
*/



/********************* GSAP *********************/
/*
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin.js';
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);


if (ScrollTrigger.isTouch !== 1) {
    gsap.from('.header__branding', {
        x: -50,
        opacity: 0,
        duration: 1,
        stagger: 0.2,
    })
    gsap.from('.header__action', {
        x: 60,
        opacity: 0,
        duration: 1,
        stagger: 0.3,
    })

}
*/


//}
